/**
 * @return {void}
 */
module.exports = function hideAllRoiCalculatorDialogSteps() {
    const selector = '[data-component="roi-calculator-loading"], [data-component="roi-calculator-success"], [data-component="roi-calculator-error"]';
    document.querySelectorAll(selector).forEach(loading => {
        if (loading instanceof HTMLElement) {
            loading.style.display = 'none';
        }
    });
}
